module.exports = "<footer class=\"footer\">\r\n<div class=\"text-center\">\r\n  <!--<a>Contact Support</a>-->\r\n</div>\r\n  <div class=\"login-footer-logo\">\r\n    <!--<img src=\"../../assets/footer-logo-final.png\" />-->\r\n  </div>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main